<script lang="ts" module>
  import { Icon } from '@/ui/base';
  import CtaButton from '@/ui/elements/buttons/CTAButton.svelte';
  import BaseCard from '@/ui/elements/card/BaseCard.svelte';
  import CardHeader, { type CardHeaderProps } from '@/ui/elements/card/CardHeader.svelte';
  import InfoCard from '@/ui/elements/card/InfoCard.svelte';
  import DropDown from '@/ui/elements/dropdown/DropDown.svelte';

  import AiContainer, { type AIContainerProps } from './cmps/AIContainer.svelte';
  import type { AIStyleProps } from './cmps/AIStyle.svelte';

  export type AICardState = 'default' | 'loading' | 'result' | 'noOptimization';

  export interface AdditionalProps {
    onLoadClick?: () => void;
    onUnloadClick?: () => void;
    onInsertClick?: AIContainerProps['onInsertClick'];
    onPromptSelect?: (item: string) => void;
    state: AICardState;
    cardLoadLabel?: string;
    promptItems?: AIContainerProps['aiStyleItems'];
    promptItemSelected?: string;
    aiSuggestions?: AIContainerProps['aiSuggestions'];
    aiDescription?: AIContainerProps['aiDescription'];
    noOptimizationText?: string;
    instructionText?: string;
  }

  export type AICardProps = AdditionalProps & Pick<CardHeaderProps, 'cardLabel'> & AIStyleProps;
</script>

<script lang="ts">
  let { cardLoadLabel: cardLoadLabelProp = 'Load', ...props }: AICardProps = $props();
  let stateProp = $derived(props.state);
</script>

<BaseCard loading={stateProp === 'loading'} hideLine={stateProp === 'default'}>
  {#snippet header()}
    <CardHeader cardLabel={props.cardLabel}>
      {#if stateProp === 'default' || stateProp === 'loading'}
        <CtaButton
          onclick={() => {
            props.onLoadClick?.();
          }}
          class="min-w-20"
          icon="MagicButton"
          variant="primary"
          loading={stateProp === 'loading'}>{cardLoadLabelProp}</CtaButton
        >
      {:else}
        <CtaButton
          variant="secondary"
          onclick={() => {
            props.onUnloadClick?.();
          }}><Icon icon="Undo" size={4.3}></Icon></CtaButton
        >
        <DropDown
          items={props.promptItems ?? []}
          disabled={!props.promptItems || props.promptItems?.length <= 1}
          selected={props.promptItemSelected ?? props.promptItems?.[0]?.value ?? ''}
          onItemClick={props.onPromptSelect}
        ></DropDown>
      {/if}
    </CardHeader>
  {/snippet}
  {#if stateProp === 'result' && !props.aiSuggestions?.length}
    <InfoCard shortText={props.instructionText ?? ''} dimension="blue"></InfoCard>
  {:else if stateProp === 'result'}
    <AiContainer
      aiDescription={props.aiDescription}
      aiSuggestions={props.aiSuggestions ?? []}
      aiStyleItems={props.aiStyleItems}
      aiStyleLabel={props.aiStyleLabel}
      aiStyleTooltip={props.aiStyleTooltip}
      onInsertClick={props.onInsertClick}
      onAIStyleClick={props.onAIStyleClick}
    ></AiContainer>
  {:else if stateProp === 'noOptimization'}
    <InfoCard shortText={props.noOptimizationText ?? ''} dimension="task"></InfoCard>
  {/if}
</BaseCard>
